import { useState, useEffect } from 'react';
import './style.scss';
import { useLanguage } from '../../lang/LangProvider';

const Fader = () => {
    const storedMetadata = JSON.parse(localStorage.getItem('metadata')) || {};
    const [fadeProp, setFadeProp] = useState({ fade: 'fade-in' });

    const [index, setIndex] = useState(0);

    const textFade = [
        { text: <Text1 /> },
        { text: <Text2 /> },
        storedMetadata?.sold_out && { text: <Text3 /> },
    ].filter(Boolean); 

    useEffect(() => {
        const interval = setInterval(() => {
            setFadeProp({ fade: 'fade-out' });
            setTimeout(() => {
                setFadeProp({ fade: '' });
                setIndex((prevIndex) => (prevIndex + 1) % textFade.length); // Circular rotation
            }, 1000);
        }, 4000);
        return () => {
            clearInterval(interval);
        };
    }, [textFade.length]);

    return (
        <div className={`fade fade-in ${fadeProp.fade}`}>
            {textFade[index].text}
        </div>
    );
}

const Text1 = () => {
    const { translate } = useLanguage();
    return (
        <>
            <h2 dangerouslySetInnerHTML={{ __html: translate('home.seluncuran_air') }}></h2>
        </>
    );
}

const Text2 = () => {
    const { translate } = useLanguage();
    return (
        <>
            <h2 dangerouslySetInnerHTML={{ __html: translate('home.petualangan') }}></h2>
        </>
    );
}

const Text3 = () => {
    const date = new Date();
    const months = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
    const formattedDate = `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
    const { translate } = useLanguage();

    return (
        <>
            <h2>
                <span className="white anim">{translate('home.tiket')} {formattedDate}</span>
                <span className="blue anim"> {translate('home.sold_out')}</span>
            </h2>
        </>
    );
}

export default Fader;